
// export const API_URL ="http://122.165.187.198:3003/hoa/api"
// export const API_URL ="https://swine-tight-definitely.ngrok-free.app/hoa/api"
// export const API_URL = "https://fashion-reserves-administrative-marsh.trycloudflare.com/hoa/api"
// export const API_URL = "https://ensures-deutsche-appearance-clock.trycloudflare.com/hoa/api"
export const API_URL = "https://detect-directories-physiology-basename.trycloudflare.com/hoa/api"

